import React, { useEffect, useRef, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Button, IconButton, InputAdornment, Paper, TextField, Typography } from '@mui/material';

import { isLoggedInUserRoot } from '@paragon/login-tools';

import { showCreateStationDialog } from '../../actions/dialogActions';
import { useAppDispatch, useAppSelector } from '../hooks';
import { AllStationsList } from '../interface/AllStationsList';

export function StationsPage() {
  const dispatch = useAppDispatch();
  const [filter, setFilter] = useState('');

  const hasFilter = filter !== '';
  const clearFilter = () => setFilter('');

  const inputRef = useRef<HTMLInputElement>(undefined);

  const isRootUser = useAppSelector(isLoggedInUserRoot);

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (hasFilter && event.code === 'Escape') {
        clearFilter();
        event.stopPropagation();
      } else if (event.ctrlKey && event.code === 'KeyF') {
        event.preventDefault();

        if (!inputRef.current) return;
        inputRef.current.focus();

        if (hasFilter) {
          inputRef.current.select();
        }
      }
    }

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [hasFilter, setFilter, inputRef]);

  return (
    <>
      <Paper elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          Find a station
        </Typography>

        <TextField
          autoFocus
          fullWidth
          margin="normal"
          label="Station Name"
          value={filter}
          onChange={(event) => void setFilter(event.target.value)}
          onFocus={(event) => event.target.select()}
          inputRef={inputRef}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: hasFilter && (
                <InputAdornment position="end">
                  <IconButton onClick={() => clearFilter()}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      </Paper>

      {isRootUser && (
        <Button
          fullWidth
          variant="outlined"
          sx={{ marginBottom: 3 }}
          onClick={() => void dispatch(showCreateStationDialog())}
        >
          Create new station
        </Button>
      )}

      <AllStationsList filter={hasFilter ? filter : undefined} />
    </>
  );
}
